var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmsEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 21.1051H7C4 21.1051 2 19.6051 2 16.1051V9.1051C2 5.6051 4 4.1051 7 4.1051H17C20 4.1051 22 5.6051 22 9.1051V12.1051",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.6051L13.87 12.1051C12.84 12.9251 11.15 12.9251 10.12 12.1051L7 9.6051",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2091 15.3751L15.6691 18.9151C15.5291 19.0551 15.3991 19.3151 15.3691 19.5051L15.1791 20.8551C15.1091 21.3451 15.4491 21.6851 15.9391 21.6151L17.2891 21.4251C17.4791 21.3951 17.7491 21.2651 17.8791 21.1251L21.4191 17.5851C22.0291 16.9751 22.3191 16.2651 21.4191 15.3651C20.5291 14.4751 19.8191 14.7651 19.2091 15.3751Z",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6992 15.8851C18.9992 16.9651 19.8392 17.8051 20.9192 18.1051",
    stroke: "#4A4A4A",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsEdit);
export default __webpack_public_path__ + "static/media/sms-edit.4f6590f74da634d028379a7dad78428f.svg";
export { ForwardRef as ReactComponent };